'use client';

import { useTranslations } from "@/i18n/client";

/** Subtle expertise strip highlighting sectors. */
export function Expertise() {
  const { isLoading } = useTranslations();
  
  if (isLoading) return null;

  const sectors = [
    { 
      name: 'Restaurantes', 
      tags: ['SEO Local', 'Reservas', 'Carta Digital', 'Google Maps'],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>
          <path d="M7 2v20"/>
          <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>
        </svg>
      )
    },
    { 
      name: 'Corporativo', 
      tags: ['B2B', 'Branding', 'Lead Gen', 'Seguridad'],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
      )
    }
  ];

  return (
    <section className="py-12 bg-[var(--color-surface)]/20 border-y border-[var(--color-border)]">
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="max-w-[400px]">
            <h3 className="font-sans font-medium text-[18px] text-[var(--color-ink)] mb-2">
              Especialistas por sector
            </h3>
            <p className="font-sans text-[14px] text-[var(--color-mute)] m-0">
              Soluciones específicas diseñadas para los retos reales de tu industria.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-16">
            {sectors.map((sector) => (
              <div key={sector.name} className="flex gap-5 items-start">
                <div className="w-10 h-10 rounded-lg bg-[var(--color-accent)]/5 flex items-center justify-center text-[var(--color-accent)] shrink-0">
                  {sector.icon}
                </div>
                <div>
                  <div className="font-sans font-bold text-[16px] text-[var(--color-ink)] mb-2">
                    {sector.name}
                  </div>
                  <div className="flex flex-wrap gap-x-3 gap-y-1">
                    {sector.tags.map(tag => (
                      <span key={tag} className="font-mono text-[10px] tracking-wider uppercase text-[var(--color-mute)]">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
